iScreenWizard.controller('LoginController', function ($scope, $state, $mdDialog, Dictionary, userService, Gebruikersbericht, Ajax) {

    $scope.userService = userService;
    $scope.forgotPasswordUrl = baseUrl + '/beheer/forgotpassword_u.php';

    $scope.$on('$viewContentLoaded', function () {
        const urlParams = new URLSearchParams(window.location.search);
        const errorMessage = urlParams.get('_errors');

        if (errorMessage) {
            showErrorMessage(errorMessage);
        }
    });

    $scope.login = function () {
        params = {
            username: userService.username,
            password: userService.password,
        };
        Ajax.post('authenticate', params).then(function (response) {
            if (response.data._errors !== null || response.data._errors.length < 1) {
                userService.password = '';
                userService.token = response.data.jwt;

                //save user data
                userService.model = response.data;
                userService.model.loginExpires = response.data.jwt_expires_at;
                userService.model.wizardNiveau = response.data.wizard_niveau;
                userService.model.wizardModules = response.data.wizard_modules;
                userService.model.passwordExpired = response.data.password_expired;
                userService.model.isSsoUser = response.data.is_sso_user;

                userService.SaveState();

                Gebruikersbericht.countUnread().then(function (nrUnreadUserMessages) {
                    var go = 'home';
                    //go to home screen and check for new messages
                    $state.go(go).then(function () {
                        if (nrUnreadUserMessages > 1) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                    .textContent(Dictionary.translate('app.youve_got_:i_new_messages', true, { i: nrUnreadUserMessages }))
                                    .ariaLabel(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                    .ok(Dictionary.translate('app.okay', true))
                            );
                        } else if (nrUnreadUserMessages == 1) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                    .textContent(Dictionary.translate('app.youve_got_one_new_message', true, { i: nrUnreadUserMessages }))
                                    .ariaLabel(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                    .ok(Dictionary.translate('app.okay', true))
                            );
                        }
                    });
                });
            } else {
                showLoginFailure(response);
            }
        }, function (response) {
            showLoginFailure(response);
        });
    };

    var showLoginFailure = function (response) {
        console.log(response);
        //reset user data
        userService.password = '';
        userService.model.loggedIn = false;
        userService.model.id = 0;
        userService.model.klantorganisatieId = 0;
        userService.model.passwordExpired = 0;
        userService.SaveState();

        errorMessage = Dictionary.translate('app.cant_log_in', true);
        if (typeof response !== 'undefined' && response !== null && response.data !== null && response.data._errors !== null && !response.data._errors.empty) {
            errorMessage = "";
            angular.forEach(response.data._errors, function (value, key) {
                errorMessage += value + '<br/>';
            });
        }

        //show alert
        $mdDialog.show(
            $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(Dictionary.translate('app.cant_log_in', true))
                .htmlContent(errorMessage)
                .ariaLabel(Dictionary.translate('app.cant_log_in', true))
                .ok(Dictionary.translate('app.okay', true))
        );
    }

    const showErrorMessage = function (message) {
        $mdDialog.show(
            $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(Dictionary.translate('app.error', true))
                .textContent(message)
                .ariaLabel(Dictionary.translate('app.error', true))
                .ok(Dictionary.translate('app.okay', true))
        );
    }

});
